<template>
	<el-row class="head-el-row">
		<el-col :span="1">
			<i :class="classn" @click="changesubmenu"></i>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-message"></i>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-star-off"></i>
		</el-col>
		<el-col :span="1">
			<div class="MapExhibition" @click="ConsoleClick()">地图展示</div>
		</el-col>
		<el-col :span="7" :offset="9" class="headword" >
			{{organName}}
			<el-dropdown @command="handleCommand" >
				<span class="el-dropdown-link">
					{{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="personalInfo">基本资料</el-dropdown-item>
					<el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
					<el-dropdown-item command="Loginout" divided>退出</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-printer"></i>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-rank"></i>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-bell"></i>
		</el-col>
		<el-col :span="1">
			<i class="el-icon-more"></i>
		</el-col>
	</el-row>
</template>
<script>
	export default {
		name:'console_head',
		data:function(){
			return {
				classn:"el-icon-d-arrow-left",
				userName:"",
				organName:"",
			}
		},
		methods:{
			ConsoleClick(){
                this.$router.push({path:'/mapconsole'});
                        },
			changesubmenu:function(){
				this.classn=(this.classn=="el-icon-d-arrow-left")?"el-icon-d-arrow-right":"el-icon-d-arrow-left";
				this.$store.commit("changeCollapse");
				this.$emit("changeSize");
			},
			handleCommand:function(command) {
				if(command=="Loginout")
				{
					var Vthis=this;
					this.$hrraxios.get(this.$api.base.loginout)
					.then((response)=>{
						var mydata=response.data;
						if(mydata.Success==true){
							Vthis.$store.commit('setUserId',"");
			                Vthis.$store.commit('setUserName',"");
			                Vthis.$store.commit('setOrganName',"");
			                sessionStorage.clear();
							Vthis.$router.push({path:'/login'});
						}else {
							Vthis.$message.error("登出失败,请联系管理员");
						}
					})
					.catch((error)=>{
						Vthis.$message.error("登出失败,请联系管理员");
						console.log(error);
					})
				}
                else if(command=="personalInfo"){
                    this.$router.push({
                        path: '/system/personal'
                    });
                }
                else if(command=="changePwd"){
                     this.$router.push({
                        path: '/system/updatepwd'
                    });
                }
			}
		},
		created(){
			this.$store.commit('getUserName');
			this.$store.commit('getOrganName');
			this.userName=this.$store.state.userName;
			this.organName=this.$store.state.organName;
		}
	}
</script>
<style>
.MapExhibition{cursor:pointer;}
.headword{ font-size: 13px; text-align: right; }
.head-el-row{width: 100%; border-bottom: 1px solid #f2f2f2; background-color: #fff;}
</style>
